import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-share-icon-buttonOnly",
  "use": "svg-icon-share-icon-buttonOnly-usage",
  "viewBox": "0 0 12 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 17\" id=\"svg-icon-share-icon-buttonOnly\"><path d=\"M6 8.4c-2.227-.027-4.365-.763-3.504 0C1.166 8.9.2 10 .2 11.2v4.4c0 .4.363.7.846.7h9.908c.484 0 .846-.3.846-.7v-4.4c0-1.2-.967-2.3-2.296-2.7.89-.786-1.354-.074-3.504-.1zM6 .2c1.96 0 3.5 1.54 3.5 3.5S7.96 7.2 6 7.2 2.5 5.66 2.5 3.7C2.5 1.88 4.04.2 6 .2z\" fill=\"#717B7F\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol